import type { CSSProperties } from "react";
import { useState } from "react";
import { cn } from "../lib/utils";

interface PhoneCountry {
  code: string;
  dial: string;
  flag: string;
}

const COUNTRIES: PhoneCountry[] = [
  { code: "US", dial: "+1", flag: "🇺🇸" },
  { code: "GB", dial: "+44", flag: "🇬🇧" },
  { code: "DE", dial: "+49", flag: "🇩🇪" },
  { code: "FR", dial: "+33", flag: "🇫🇷" },
  { code: "ES", dial: "+34", flag: "🇪🇸" },
  { code: "IT", dial: "+39", flag: "🇮🇹" },
  { code: "CA", dial: "+1", flag: "🇨🇦" },
  { code: "AU", dial: "+61", flag: "🇦🇺" },
  { code: "JP", dial: "+81", flag: "🇯🇵" },
  { code: "CN", dial: "+86", flag: "🇨🇳" },
  { code: "IN", dial: "+91", flag: "🇮🇳" },
  { code: "BR", dial: "+55", flag: "🇧🇷" },
  { code: "MX", dial: "+52", flag: "🇲🇽" },
  { code: "RU", dial: "+7", flag: "🇷🇺" },
  { code: "KR", dial: "+82", flag: "🇰🇷" },
  { code: "NL", dial: "+31", flag: "🇳🇱" },
  { code: "SE", dial: "+46", flag: "🇸🇪" },
  { code: "CH", dial: "+41", flag: "🇨🇭" },
  { code: "AT", dial: "+43", flag: "🇦🇹" },
  { code: "PL", dial: "+48", flag: "🇵🇱" },
];

interface PhoneInputProps {
  value?: string;
  onChange?: (phone: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
}

export function PhoneInput({
  value = "",
  onChange,
  placeholder = "123 456 7890",
  disabled = false,
  className,
  style,
}: PhoneInputProps) {
  const [country, setCountry] = useState<PhoneCountry>(COUNTRIES[0]);
  const [open, setOpen] = useState(false);

  function handleSelect(c: PhoneCountry) {
    setCountry(c);
    setOpen(false);
  }

  return (
    <div className={cn("pi-root", disabled && "pi-disabled", className)} style={style}>
      <div className="pi-country" onClick={() => !disabled && setOpen(o => !o)}>
        <span className="pi-flag">{country.flag}</span>
        <span className="pi-dial">{country.dial}</span>
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" className={cn("pi-chevron", open && "pi-chevron-open")}>
          <path d="M2 3.5l3 3 3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <div className="pi-divider" />
      <input
        type="tel"
        className="pi-input"
        value={value}
        onChange={e => onChange?.(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="tel"
      />
      {open && (
        <div className="pi-dropdown">
          {COUNTRIES.map(c => (
            <button
              key={c.code}
              type="button"
              className={cn("pi-option", c.code === country.code && "pi-option-active")}
              onClick={() => handleSelect(c)}
            >
              <span className="pi-flag">{c.flag}</span>
              <span className="pi-option-code">{c.code}</span>
              <span className="pi-dial">{c.dial}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
